import { useEffect, useRef, useState } from 'react';
import styles from './NewsCard.module.css';
import { Link } from 'react-router-dom';
import cn from 'classnames';

export interface NewsData {
  id: number;
  topic: string;
  date: string;
  project: string;
  title: string;
  shortDescription: string;
  content?: {
    type: string;
    text?: string;
    items?: string[];
    src?: string;
    caption?: string;
  }[];
}

export default function NewsCard({ id, project, topic, date, title, shortDescription, content }: NewsData) {
  const titleRef = useRef<HTMLParagraphElement>(null);
  const [lineClamp, setLineClamp] = useState(4);

  useEffect(() => {
    if (titleRef.current) {
      const titleHeight = titleRef.current.clientHeight;
      const lineHeight = parseInt(window.getComputedStyle(titleRef.current).lineHeight, 10);

      const titleLines = Math.round(titleHeight / lineHeight);

      if (titleLines === 1) {
        setLineClamp(4);
      } else if (titleLines === 2) {
        setLineClamp(3);
      } else if (titleLines ===3) {
        setLineClamp(2);
      }
    }
  }, [title]);

  const renderText = (text: string) => {
    return <span dangerouslySetInnerHTML={{ __html: text }} />;
  };

  return (
    <Link
      className={styles.wrapper}
      to={`/news/${id}`}
      state={{ news: { id, project, topic, date, title, shortDescription, content } }}
    >
      <div className={styles.card_content}>
        <div className={styles.top}>
          <p className={cn('text_body_b3', styles.date)}>{date}</p>
          <span className={styles.point}></span>
          <p className={cn('text_body_b3', styles.project)}>{project}</p>
          <span className={styles.point}></span>
          <p className={cn('text_body_b3', styles.topic)}>{topic}</p>
        </div>
        <p ref={titleRef} className={cn('text_subheaders_sh1', styles.title)}>
          {renderText(title)}
        </p>
        <p
          className={cn('text_body_b2', styles.short_descr)}
          style={{ WebkitLineClamp: lineClamp, lineClamp: lineClamp }}
        >
          {renderText(shortDescription)}
        </p>
      </div>
    </Link>
  );
}